import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { OrderItem } from './models/item';
import { OrderItemPayload } from './models/item-payload';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class OrderItemService
  extends StoreBaseService<OrderItem, OrderItemPayload> {

  get entityType(): string {
    return EntityTypes.orderItem;
  }

  get resourceName(): string {
    return 'order-item';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
